<div class="row" >
  <div class="col-md-6 login-left text-center p-5">
      <div class="p-3 title-case" style="font-weight:bold; text-transform:uppercase;font-size: 24px;">
          <img class="dark-logo" style="width: 150px;" src={{logo}} alt="DOWC"> <span class="mt-1">
          </span>
        </div>
      <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by click <a class="btn-link text-info" style="color: #fff;" href="/signup">here</a>. If you already have an account, please login to pick up where you left off.</p>
      <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link text-info" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you </p>! -->
      <div class="help-container">
        <div class="help-section">
          <p class="help-text" (click)="openHelpPopup()">
            <i class="hellp-popup-icons"></i>
          </p>
        </div>
      </div>
    </div>  
  <div class="col-md-6 login-right text-center p-5 primary-background" style="background-color:#009B4C;margin-right: -30px;color: #ffffff;min-height:100vh;">
  <p style="font-size: 30px;font-weight: bold;text-align: center;"><img
    src={{applogo}}
    alt="DOWC"
    class="dark-logo"
    style="width: 140px;"
  /> Claims</p>
  <div class="card-body form-items" *ngIf="forgotPasswordForm">
    <form
      [formGroup]="forgotPasswordForm"
      (ngSubmit)="onSubmit()"
      class="form-horizontal form-material"
      id="forgotPasswordForm"
      novalidate
    >
      <h3 class="box-title text-white m-b-1">Forgot password</h3>
      <app-missed-errors></app-missed-errors>
      <div class="form-group">
        <div class="col-xs-12">
          <app-form-error-wrapper
            [apiErrorType]="'email'"
            [control]="forgotPasswordForm.controls['email']"
            [controlName]="'Email'"
            [apiErrorType]="'email'"
          >
            <input
              class="form-control"
              type="email"
              formControlName="email"
              placeholder="Enter Email"
            />
          </app-form-error-wrapper>
        </div>
      </div>
      <div class="form-group m-t-10 m-b-0">
        <div class="col-xs-3">
          <button class="btn btn-white text-info bold pl-4 pr-4"
          [disabled]="forgotPasswordForm.invalid || isLoading"
          >
            <app-button-loader
              [isLoading]="isLoading"
              [label]="'Send Email'"
            ></app-button-loader>
          </button>
          <a class="text-white m-l-5" [routerLink]="['/login']">
            <b>Sign In</b>
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="col-md-6 login-bottom text-center p-5">
  <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by clicking on the link below. If you already have an account, please login to pick up where you left off.</p>
 <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link text-info" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you! </p>-->
 <div class="help-container">
  <div class="help-section">
    <p class="help-text" (click)="openHelpPopup()">
      <i class="hellp-popup-icons"></i>
    </p>
  </div>
</div>
</div>
</div>

